import React, { useState, useEffect, useCallback, useLayoutEffect } from 'react';

import ReactHtmlParser from 'react-html-parser';
import Shadow from '../../../utils/shadowDom';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Slide,
    TextField,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Divider,
    Autocomplete,
    IconButton,
    RadioGroup,
    FormControlLabel,
    Radio,
    ListSubheader,
    Alert,
    Tooltip,
    Link,
} from '@mui/material';

import useNotification from '../../Notification';
import { DemoContainer } from "@mui/x-date-pickers/internals/demo"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { ptBR as localePTBR } from "@mui/x-date-pickers/locales"

import { number2dayweek } from '../../Report/NewDetailedRegister/detailed_register_leftmenu'
import { postEmailAttachments } from '../../Crm/TabButtons/SendMessage/SendEmail';
import dayjs from "dayjs"

export const default_timezone = "America/Sao_Paulo"


import { useTelephony } from "../../../contexts/TelephonyContext"
import { platforms } from "../../Agenda"

import { getSession } from "../../../auth"
import api from "../../../api"
import { getAttachments } from '../../Chat/MessagesArea/ChatWindow/MessageItem';

import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete'
import HelpIcon from '@mui/icons-material/Help';
import ReportIcon from '@mui/icons-material/Report';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';

import Loading from '../../Loading';
import ParameterFiller from "../../Crm/Templates/ParameterFiller"

import userPermissions from "../../User/Permissions"

import ClientDialog from "../../Dialogs/Client"
import formatPhone from "../../../utils/format_phone"
import { generateUniqueNick  } from "../../../utils/utils"
import { handleContactCreateErrors } from "../../Journeys/opportunity-contact-errors"
import { stripHtmlRegex } from '../../../utils/emojiDict';
import eventObject, { stateTranslation }from '../event-object';

import "./styles.css"
import { distributedCalendar } from '../DistributedCalendar';
import ConfirmationDialog from '../../Dialogs/Confirmation';
import oauthRequest from '../../../utils/oauth_request';
import DraggableBox from '../../../utils/draggableBox';

const userGroups = userPermissions()

const timeouts = {
    contact: 0,
    enterprise: 0,
    groups: 0
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const channelTranslations = {
    "whatsapp": "WhatsApp",
    "telegram": "Telegram",
    "instagram": "Instagram",
    "email": "E-mail",
    "messenger": "Messenger",
    "sms": "SMS"
}

export const checkDisabled = (key, contact) => {
    switch (key) {
        case 'whatsapp':
            return !Boolean(contact?.telephone)
        case 'sms':
            return !Boolean(contact?.telephone)
        case 'voice':
            return !Boolean(contact?.telephone)
        case 'email':
            return !Boolean(contact?.email)
        default:
            return false
    }
}

const notificationTimes = {
    '1': '1 minuto',
    '5': '5 minutos',
    '10': '10 minutos',
    '15': '15 minutos',
    '30': '30 minutos',
    '60': '1 hora',
    '90': '1 hora e meia',
    '120': '2 horas'
}

const getCalendarNotificationBody = (data) => ([
    "{{nome_cliente}}",
    data.title,
    dayjs(data.startDate).format("DD/MM/YYYY HH:mm"),
])

const getCalendarStatusNotificationBody = (data) => ([
    "{{nome_cliente}}",
    data.title,
])

const arrayToBodyParameters = (parameters) => (
    Object.fromEntries(parameters.map((value, index) => [String(index), value]))
)

const kwikReminderRecurrences = new Set(["WEEKDAYS", "WEEKLY", "MONTHLY", "YEARLY"])

const getKwikReminderRecurrence = (value) => (
    kwikReminderRecurrences.has(value) ? value : ""
)



const handleWhatsappActivity = async (data, setState, setLoading, activity = true) => {
    if (data?.mediaParameters?.headerfile && typeof (data?.mediaParameters?.headerfile) !== 'string') {
        setLoading(true)
        const file = new FormData()
        file.append('file', data.mediaParameters.headerfile)
        
        const res = await api.post(`api/whatsapp/uploadmedia/`, file, { timeout: 15000 })
        setLoading(false)
        
        if (res.status !== 200) {
            if (res.code === 'ECONNABORTED' || res.message?.includes('timeout')) {
                useNotification(
                    'Tempo de resposta excedido',
                    'O tempo limite para upload da imagem foi excedido. Verifique sua conexão e tente novamente.',
                    'danger'
                )
            } else {
                useNotification(
                    'Erro ao fazer upload',
                    'Não foi possível fazer upload da imagem. Tente novamente.',
                    'danger'
                )
            }
            return
        }
        
        data.mediaParameters.headerURL = res.data
        delete data.mediaParameters.headerfile
    }
    
    if (data?.mediaParameters?.headerURL) {
        delete data.mediaParameters.headerfile
    }
    
    if (activity)
        setState(prevState => ({ ...prevState, activity: { ...prevState.activity, 'whatsapp': data } }))
    else
        setState(prevState => ({ ...prevState, whatsapp_notification: data }))
}

const handleChangeWhatsappImage = async (setState, setLoading) => {
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = 'image/*'
    
    input.onchange = async (e) => {
        const file = e.target.files[0]
        if (!file) return
        
        setLoading(true)
        const formData = new FormData()
        formData.append('file', file)
        
        const res = await api.post(`api/whatsapp/uploadmedia/`, formData, { timeout: 15000 })
        setLoading(false)
        
        if (res.status !== 200) {
            if (res.code === 'ECONNABORTED' || res.message?.includes('timeout')) {
                useNotification(
                    'Tempo de resposta excedido',
                    'O tempo limite para upload da imagem foi excedido. Verifique sua conexão e tente novamente.',
                    'danger'
                )
            } else {
                useNotification(
                    'Erro ao fazer upload',
                    'Não foi possível fazer upload da imagem. Tente novamente.',
                    'danger'
                )
            }
            return
        }
        
        setState(prevState => ({
            ...prevState,
            activity: {
                ...prevState.activity,
                whatsapp: {
                    ...prevState.activity.whatsapp,
                    mediaParameters: {
                        ...prevState.activity.whatsapp.mediaParameters,
                        headerURL: res.data,
                        headerfile: undefined
                    }
                }
            }
        }))
        
        useNotification(
            'Sucesso',
            'Imagem atualizada com sucesso!',
            'success'
        )
    }
    
    input.click()
}

const handleEmailActivity = async (data, setState) => {
    const emailMessageData = data.emailMessageData
    if (emailMessageData && emailMessageData.attachments?.length) {
        if (emailMessageData && emailMessageData.attachments?.filter(each => !each.loaded)?.length) {
            emailMessageData.bodyTextContent = await postEmailAttachments(emailMessageData.bodyTextContent, emailMessageData.attachments, data.email)
            if (emailMessageData.bodyTextContent === -1) {
                useNotification(
                    'Ops!',
                    'Não foi possível importar os anexos.',
                    'error'
                )
                return
            }
            const attachmentregex = /\(emailattachment\)([\s\S]*?)\(\/emailattachment\)/g
            const attachments_obj = getAttachments(attachmentregex, emailMessageData.bodyTextContent)
            emailMessageData.bodyTextContent = attachments_obj.response
            emailMessageData.attachments = [...attachments_obj.data.map(e => ({ ...e, loaded: true })), ...emailMessageData.attachments?.filter(each => each.loaded)]

        }
    }

    setState(prevState => ({ ...prevState, activity: { ...prevState.activity, 'email': data } }))
}

export const usablePlatforms = Object.entries(getSession()?.profile?.enterprise?.platforms || {}).
    filter(([key, value]) => !["id", "email_boxes", "scout", "scout_licenses", "chat_web"].includes(key) && value).
    sort(([a], [b]) => a.localeCompare(b))

export const renderWhatsAppMessage = (data) => {
    let parsedHeader, parsedBody, parsedFooter, attachments 
    const header = data.selectedTemplate.components.find((component) => component.type === "HEADER")
    if (header) {
        let mediaUrl = data.mediaParameters["headerfile"] ?? data.mediaParameters["headerURL"] ?? header.example?.header_handle?.[0]
        if (mediaUrl instanceof File)
            mediaUrl = URL.createObjectURL(mediaUrl)
        switch (header.format) {
            case "IMAGE":
                parsedHeader = (
                    <img src={mediaUrl} style={{ maxWidth: "100%", marginBottom: ".5rem" }}/>
                )
                break
            case "DOCUMENT":
                parsedHeader = (
                    <a href={mediaUrl} target="_blank" rel="noopener noreferrer" style={{ marginBottom: ".5rem" }}>
                        Documento
                    </a>
                )
                break
            case "VIDEO":
                parsedHeader = (
                    <video controls style={{ maxWidth: "100%", marginBottom: ".5rem" }}>
                        <source src={mediaUrl} />
                    </video>
                )
                break
            case "TEXT":
                parsedHeader = (
                    <div style={{ marginBottom: "1rem", fontWeight: "bold" }}>{header.text}</div>
                )
                break
            default:
                break
        }
    }

    const body = data.selectedTemplate.components.find((component) => component.type === "BODY")
    if (body) {
        parsedBody = body["text"]
        const bodyParams = data.mediaParameters?.body
        if (bodyParams && typeof bodyParams === "object") {
            Object.entries(bodyParams).forEach(([key, value]) => {
                const placeholder = `{{${parseInt(key, 10) + 1}}}`
                parsedBody = parsedBody.replaceAll(placeholder, value)
            })
        }
    }

    const footer = data.selectedTemplate.components.find((component) => component.type === "FOOTER")
    if (footer)
        parsedFooter = (
            <div style={{ marginTop: "1rem", color: "gray" }}>{footer.text}</div>
        )

    return (
        <Box className="summary-message-template">
            {parsedHeader ?? null}
            {parsedBody &&
                <pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>
                    {parsedBody}
                </pre>
            }
            {parsedFooter ?? null}
        </Box>
    )
}

const Event = ({ open, title, timelineTasks=[], processEvents=()=>{}, handleClose,
 isSupervisor, myTeam, selectedEvent, setProfile, setupWhatsAppNotify, 
 setupSMSNotify, setupEmailNotify, setParentCustomEvents, calendarNotification,
 lock = false, hideNotifyRow = false, }) => {

    const { callContact } = useTelephony()
    const [contacts, setContacts] = useState([])
    const [enterprises, setEnterprises] = useState([])
    const [contactGroups, setContactGroups] = useState([])
    const [loading, setLoading] = useState(false)
    const [smallLoading, setSmallLoading] = useState(false)
    const [contactSearch, setContactSearch] = useState("")
    const [enterpriseSearch, setEnterpriseSearch] = useState("")
    const [contactGroupSearch, setContactGroupSearch] = useState("")
    const [confirmation, setConfirmation] = useState(false)
    const [deleteConfirmation, setDeleteConfirmation] = useState(false)
    const [userTeam, setUserTeam] = useState([])
    const [ready, setReady] = useState(false)
    const [confirmEvent, setConfirmEvent] = useState(null)
    const [showHTML, setShowHTML] = useState(false)

    const [contactType, setContactType] = useState(
        (selectedEvent?.contact_group_data)
            ? "contact_group"
            : (selectedEvent?.contact_enterprise_data)
                ? "contact_enterprise"
                : "contact"
    )

    const [events, setEvents] = useState([])
    const [customEvents, setCustomEvents] = useState([])
    const [enterpriseEvents, setEnterpriseEvents] = useState([])

    const [eventSettings, setEventSettings] = useState({})
    const [templates, setTemplates] = useState([])

    const [showCreateNewEvent, setShowCreateNewEvent] = useState(false)
    const [newEventName, setNewEventName] = useState("")

    const [state, setState] = useState(eventObject({
        object: selectedEvent, provider: selectedEvent.calendar, source: selectedEvent.email
    }))

    useEffect(() => {
        if (contactType !== "contact")
            return

        setContactSearch(
            (state.contact && typeof state.contact === "object")
                ? (state.contact.name || state.contact.email || state.contact.telephone || "")
                : ""
        )
    }, [state.contact, contactType])

    const [createNewContactDialog, showCreateNewContactDialog] = useState(false)

    const contactSearchFn = useCallback(async (search='', timeout=1000) => {
        clearTimeout(timeouts.contact)
        const Fn = async () => {
            try {
                setSmallLoading(true)
                let url = `api/enterprises/${getSession().profile.enterprise.id}/contacts/?limit=25&offset=0`
                if (search)
                    url = `${url}&name__contains=${search}`
                const response = await api.get(url)
                setContacts(response.data.results)
            } catch (error) { } finally {
                setSmallLoading(false)
            }
        }
        if (timeout){
            timeouts.contact = setTimeout(Fn, timeout)
        } else {
            return Fn()
        }
    }, [])

    const getContactsEmails = async (data) => {
        const emails = [data.email]
        if (data.contact) {
            if (! data.contact.email)
                throw "O contato escolhido não possui e-mail cadastrado."
            emails.push(data.contact.email)
        } else {
            const enterpriseId = getSession()?.profile?.enterprise?.id
            if (data.contact_enterprise) {
                const response = await api.get(`api/enterprises/${enterpriseId}/contact_enterprises/${data.contact_enterprise.id}/get_contacts_emails/`)
                emails.push(...response.data)
            } else if (data.contact_group) {
                const response = await api.get(`api/enterprises/${enterpriseId}/contact_group/${data.contact_group}/get_contacts_emails/`)
                emails.push(...response.data)
            }
        }
        return emails
    }

    const getContactsTelephones = async (data, external = false) => {
        let response
        
        const telephones = []
        const enterpriseId = getSession()?.profile?.enterprise?.id
        
        if (external) {
            const emails = []
            switch (data.calendar) {
                case "GOOGLE_CALENDAR":
                case "MICROSOFT_CALENDAR":
                    emails.push(...data.attendees.map((row) => row.email))
                    break
                default:
                    console.warn(`Unknown calendar type ${data.calendar}.`)
                    break
            }
            response = await api.post(`api/enterprises/${enterpriseId}/contacts/get_telephones_from_emails/`, {
                "emails": emails
            })
            telephones.push(...response.data)
        } else {
            if (data.contact) {
                if (data.contact.telephone)
                    telephones.push(data.contact.telephone)
            } else {
                if (data.contact_enterprise) {
                    const response = await api.get(`api/enterprises/${enterpriseId}/contact_enterprises/${data.contact_enterprise.id}/get_contacts_telephones/`)
                    telephones.push(...response.data)
                } else if (data.contact_group) {
                    const response = await api.get(`api/enterprises/${enterpriseId}/contact_group/${data.contact_group}/get_contacts_telephones/`)
                    telephones.push(...response.data)
                }
            }   
        }
        return telephones
    }

    const sendWhatsappNotification = useCallback(async (data, template, parameters, originNumber, type = "CREATE") => {
        const today = dayjs()
        if (dayjs(data.startDate).isAfter(today) || dayjs(data.startDate).isSame(today)) {
            let telephones = []
            switch (type) {
                case "CREATE":
                    telephones = await getContactsTelephones(data)
                    break
                case "UPDATE":
                case "DELETE":
                    telephones = await getContactsTelephones(data, true)
                    break
                default:
                    break
            }
            await api.post(`api/whatsapp/notification/`, {
                ...data.whatsapp_notification,
                "to"         : telephones,
                "template"   : template,
                "parameters" : parameters,
                "from"       : originNumber,
                "queue_name" : ""
            }, { timeout: 0 })
        }
    }, [])

    const createReminder = useCallback(async (data, template, parameters, date, originNumber, reminderType, externalEventId) => {
        const today = dayjs()
        if (dayjs(date).isBefore(today)) {
            return
        }

        const bodyParameters = arrayToBodyParameters(parameters)
        const target = distributedCalendar.data_dict[`${data.email}_${data.calendar}`]?.owner ?? getSession().id

        await api.post(`api/enterprises/${getSession().profile.enterprise.id}/tasks/`, {
            "description": "INTERNAL-NOTIFICATION",
            "target_date": date,
            "contact": (data.contact) ? data.contact.id : null,
            "contact_enterprise": (data.contact_enterprise) ? data.contact_enterprise.id : null,
            "contact_group": (data.contact_group) ? data.contact_group.id : null,
            "event": "ACTIVE",
            "status": "SCHEDULED",
            "owner": getSession().id,
            "target": target,
            "is_recurrent": getKwikReminderRecurrence(data.is_recurrent),
            "activity": {
                "whatsapp": {
                    "selectedTemplate": template,
                    "parameters": [
                        {
                            "type": "BODY",
                            "amount": parameters.length
                        }
                    ],
                    "mediaParameters": {
                        "body": bodyParameters
                    },
                    "originNumber": originNumber
                }
            },
            "external_event_id": externalEventId,
            "external_reminder_type": reminderType,
            "external_provider": data.calendar,
            "external_email": data.email,
        })
    }, [])

    const removeExternalNotifications = useCallback(async (eventOrId) => {
        const externalEventIds = Array.from(new Set(
            (typeof eventOrId === "object"
                ? [eventOrId?.id, eventOrId?.is_recurrent]
                : [eventOrId]
            ).filter((id) => id && id !== "UNIQUE")
        ))

        await Promise.all(externalEventIds.map((externalEventId) => (
            api.delete(`api/enterprises/${getSession().profile.enterprise.id}/tasks/external/`, {
                data: {
                    external_event_id: externalEventId,
                },
            })
        )))
    }, [])

    const createConfiguredReminders = useCallback(async (data, externalData, templates) => {
        const reminderParameters = getCalendarNotificationBody(data)

        if (calendarNotification?.first_reminder_template && calendarNotification?.first_reminder_offset) {
            const reminderTemplate = templates.find((template) => template.name === calendarNotification?.first_reminder_template) ?? null
            const reminderDate = dayjs(data.startDate).subtract(calendarNotification?.first_reminder_offset, "hours").format("YYYY-MM-DDTHH:mm")
            if (reminderTemplate) {
                await createReminder(data, reminderTemplate, reminderParameters, reminderDate, calendarNotification?.origin_number, "FIRST", externalData.id)
            }
        }

        if (calendarNotification?.second_reminder_template && calendarNotification?.second_reminder_offset) {
            const reminderTemplate = templates.find((template) => template.name === calendarNotification?.second_reminder_template) ?? null
            const reminderDate = dayjs(data.startDate).subtract(calendarNotification?.second_reminder_offset, "minutes").format("YYYY-MM-DDTHH:mm")
            if (reminderTemplate) {
                await createReminder(data, reminderTemplate, reminderParameters, reminderDate, calendarNotification?.origin_number, "SECOND", externalData.id)
            }
        }
    }, [calendarNotification, createReminder])

    const buildExternalEventObject = (event, data) => eventObject({
        object: {
            ...event,
            send_notification: data.send_notification,
            send_whatsapp_notification: data.send_whatsapp_notification,
            whatsapp_notification: data.whatsapp_notification,
        },
        provider: data.calendar,
        source: data.email,
    })

    const handleCreateNotifications = useCallback(async (data, externalData) => {
        if (!data.send_whatsapp_notification) {
            return
        }

        const templates = await getNumberTemplates(calendarNotification?.origin_number)

        if (calendarNotification?.on_create_template) {
            await sendWhatsappNotification(
                data,
                calendarNotification?.on_create_template,
                getCalendarNotificationBody(data),
                calendarNotification?.origin_number
            )
        }

        await createConfiguredReminders(data, externalData, templates)
    }, [calendarNotification, createConfiguredReminders, sendWhatsappNotification])

    const handleUpdateNotifications = useCallback(async (data, externalData) => {
        if (!data.send_whatsapp_notification) {
            await removeExternalNotifications(data)
            return
        }

        if (calendarNotification?.on_update_template) {
            await sendWhatsappNotification(
                data,
                calendarNotification.on_update_template,
                getCalendarStatusNotificationBody(data),
                calendarNotification.origin_number,
                "UPDATE"
            )
        }

        const templates = await getNumberTemplates(calendarNotification?.origin_number)
        await removeExternalNotifications(data)
        await createConfiguredReminders(data, externalData, templates)
    }, [calendarNotification, createConfiguredReminders, removeExternalNotifications, sendWhatsappNotification])

    const handleDeleteNotifications = useCallback(async (data, externalData) => {
        if (data.send_whatsapp_notification && calendarNotification?.on_delete_template) {
            await sendWhatsappNotification(
                data,
                calendarNotification.on_delete_template,
                getCalendarStatusNotificationBody(data),
                calendarNotification.origin_number,
                "DELETE"
            )
        }

        await removeExternalNotifications(data)
    }, [calendarNotification, removeExternalNotifications, sendWhatsappNotification])

    const updateEvent = async (data, recurrent) => {
        let response, body, url
        switch (data.calendar) {
            case "GOOGLE_CALENDAR":
                body = {
                    "summary"     : data.title,
                    "description" : data.description,
                    "location"    : data.localization,
                    "start"       : { "dateTime": dayjs(data.startDate).format("YYYY-MM-DDTHH:mm:ssZ") },
                    "end"         : { "dateTime": dayjs(data.endDate).format("YYYY-MM-DDTHH:mm:ssZ") },
                    "attendees"   : data.attendees.map(attendee => 
                        ({email: attendee.email, responseStatus: stateTranslation[attendee.status]?.vGoogle || attendee.status}))
                }

                url = `/${data.id}`
                if (data.send_notification)
                    url += "?sendUpdates=all"
                
                setLoading(true)
                response = await oauthRequest([{
                    url      : url,
                    method   : "PATCH",
                    provider : data.calendar.toLowerCase(),
                    email    : data.email,
                    user_id  : distributedCalendar.data_dict[`${data.email}_${state.calendar}`]?.owner,
                    body     : body
                }])

                if (!response[0]) {
                    useNotification(
                        "Ops",
                        "Algo deu errado, tente novamente.",
                        "danger"
                    )
                    return
                }

                await handleUpdateNotifications(data, response[0])
                setLoading(false)

                processEvents(timelineTasks.map(
                    (event) => event.id === response[0].id
                        ? buildExternalEventObject(response[0], data)
                        : event
                ))

                handleClose()
                useNotification(
                    "Sucesso",
                    "Evento atualizado com sucesso.",
                    "success"
                )
                break
            case "MICROSOFT_CALENDAR":
                body = {
                    "subject"     : data.title,
                    "body": {
                        "contentType": "HTML",
                        "content": data.description,
                    },
                    "location": {
                        "displayName": data.localization
                    },
                    "start": {
                        "dateTime": dayjs(data.startDate).format("YYYY-MM-DDTHH:mm:ss") ,
                        "timeZone": "America/Sao_Paulo"
                    },
                    "end": {
                        "dateTime":  dayjs(data.endDate).format("YYYY-MM-DDTHH:mm:ss") ,
                        "timeZone": "America/Sao_Paulo"
                    },
                    "attendees": data.attendees.map(attendee => ({
                        "emailAddress": {
                            "address": attendee.email,
                            "name": "Pessoa Convidada"
                        },
                        "type": "required"
                    }),
                )}

                url = `events/${data.id}`
                if (data.send_notification)
                    url += "?sendUpdates=all"
                
                setLoading(true)
                response = await oauthRequest([{
                    url      : url,
                    method   : "PATCH",
                    provider : data.calendar.toLowerCase(),
                    email    : data.email,
                    user_id  : distributedCalendar.data_dict[`${data.email}_${state.calendar}`]?.owner,
                    body     : body
                }])

                if (!response[0]) {
                    useNotification(
                        "Ops",
                        "Algo deu errado, tente novamente.",
                        "danger"
                    )
                    setLoading(false)
                    return
                }

                await handleUpdateNotifications(data, response[0])
                setLoading(false)

                processEvents(timelineTasks.map(
                    (event) => event.id === response[0].id
                        ? buildExternalEventObject(response[0], data)
                        : event
                ))

                handleClose()
                useNotification(
                    "Sucesso",
                    "Evento atualizado com sucesso.",
                    "success"
                )
                break
            default:
                setLoading(true)
                response = await api.patch(`api/enterprises/${getSession().profile.enterprise.id}/tasks/${data.id}/`, {
                    ...data,
                    description: data.title,
                    long_description: data.description,
                    target_date: dayjs(data.startDate).format("YYYY-MM-DDTHH:mm"),
                    contact: (data.contact) ? data.contact.id : null,
                    contact_enterprise: (data.contact_enterprise) ? data.contact_enterprise.id : null,
                    is_recurrent: (data.is_recurrent === "UNIQUE") ? "" : data.is_recurrent,
                    update_recurrently: recurrent
                })
                setLoading(false)
                if (response.status === 200) {
                    const data_dict = Object.fromEntries(response.data.map((data)=> ([data.id, data])))
                    const kupdatedEvents = timelineTasks.map((event) => data_dict[event.id] ?
                     eventObject({object: data_dict[event.id], provider: "KWIK", source: data_dict[event.id].target_username})
                      : 
                      event)
                    processEvents(kupdatedEvents)

                    handleClose()
                    useNotification(
                        "Sucesso",
                        "Evento atualizado com sucesso.",
                        "success"
                    )
                    return
                }
                useNotification(
                    "Ops",
                    "Algo deu errado, tente novamente.",
                    "danger"
                )
            break
        }
    }

    const dayMap = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"]

    const createExternalEvent = async (data) => {
        if (data.startDate >= data.endDate) {
            useNotification(
                "Atenção",
                "A data e hora de início deve ser menor que a data e hora de fim.",
                "warning"
            )
            return
        }

        let attendees = []
        try {
            const emails = await getContactsEmails(data)
            attendees = emails.map((email) => ({ email }))
        } catch (warning) {
            useNotification("Atenção", warning, "warning")
            return
        }

        switch (data.calendar) {
            case "GOOGLE_CALENDAR":
                const body = {
                    "summary"     : data.title,
                    "description" : data.description,
                    "location"    : data.localization,
                    "start"       : {
                        "dateTime" : dayjs(data.startDate).format("YYYY-MM-DDTHH:mm:ss"),
                        "timeZone" : "America/Sao_Paulo"
                    },
                    "end"         : {
                        "dateTime" : dayjs(data.endDate).format("YYYY-MM-DDTHH:mm:ss"),
                        "timeZone" : "America/Sao_Paulo"
                    },
                    "attendees"   : attendees
                }

                if (["WEEKLY", "MONTHLY", "YEARLY", "WEEKDAYS"].includes(data.is_recurrent)) {
                    body["recurrence"] = [
                        data.is_recurrent === "WEEKDAYS"
                            ? "RRULE:FREQ=WEEKLY;BYDAY=MO,TU,WE,TH,FR"
                            : `RRULE:FREQ=${data.is_recurrent}`
                    ]
                }

                const params = new URLSearchParams()
                if (data.conference_room) {
                    params.append("conferenceDataVersion", "1")
                    body["conferenceData"] = {
                        "createRequest": {
                            "requestId": crypto.randomUUID()
                        }
                    }
                }
                if (data.send_notification)
                    params.append("sendUpdates", "all")
                
                setLoading(true)
                const response = await oauthRequest([{
                    url      : `?${params.toString()}`,
                    method   : "POST",
                    provider : data.calendar.toLowerCase(),
                    email    : data.email,
                    user_id  : distributedCalendar.data_dict[`${data.email}_${state.calendar}`]?.owner,
                    body     : body 
                }])

                if (! response[0]) {
                    useNotification(
                        "Ops",
                        "Algo deu errado, tente novamente.",
                        "danger"
                    )
                    setLoading(false)
                    return
                }

                if (data.send_whatsapp_notification) 
                    await handleCreateNotifications(data, response[0])
                setLoading(false)

                if (["WEEKLY", "MONTHLY", "YEARLY", "WEEKDAYS"].includes(data.is_recurrent)) {
                    distributedCalendar.reload_calendar()
                } else {
                    const updatedEvents = [...timelineTasks, buildExternalEventObject(response[0], data)]
                    processEvents(updatedEvents)
                }

                handleClose()
                useNotification(
                    "Sucesso",
                    "Evento criado com sucesso.",
                    "success"
                )
                break
            case "MICROSOFT_CALENDAR":
                const mbody = {
                    "subject": data.title,
                    "body": {
                        "contentType": "HTML",
                        "content": data.description,
                    },
                    "start": {
                        "dateTime": dayjs(data.startDate).format("YYYY-MM-DDTHH:mm:ss") ,
                        "timeZone": "America/Sao_Paulo"
                    },
                    "end": {
                        "dateTime":  dayjs(data.endDate).format("YYYY-MM-DDTHH:mm:ss") ,
                        "timeZone": "America/Sao_Paulo"
                    },
                    "location": {
                        "displayName": data.localization
                    },
                    "isOnlineMeeting": data.conference_room,
                    "onlineMeetingProvider": "teamsForBusiness",
                    "responseRequested": data.send_notification,
                    "attendees": attendees.map(attendee => ({
                        "emailAddress": {
                            "address": attendee.email,
                            "name": "Pessoa Convidada"
                        },
                        "type": "required"
                        }),
                    ),
                }

                if (["WEEKLY", "MONTHLY", "YEARLY", "WEEKDAYS"].includes(data.is_recurrent)) {
                    if (data.is_recurrent === "WEEKDAYS") {
                        mbody["recurrence"] = {
                            "pattern": {
                                "type": "weekly",
                                "interval": 1,
                                "daysOfWeek": ["monday", "tuesday", "wednesday", "thursday", "friday"]
                            },
                            "range": {
                                "type": "noEnd",
                                "startDate": dayjs(data.startDate).format("YYYY-MM-DD")
                            }
                        }
                    } else {
                        mbody["recurrence"] = {
                            "pattern": {
                                "type": data.is_recurrent.toLowerCase(),
                                "interval": 1,
                                "daysOfWeek": [
                                    dayMap[dayjs(data.startDate).day()]
                                ]
                            },
                            "range": {
                                "type": "noEnd",
                                "startDate": dayjs(data.startDate).format("YYYY-MM-DD")
                            }
                        }
                    }
                }

                setLoading(true)
                const mresponse = await oauthRequest([{
                    url      : 'events',
                    method   : "POST",
                    provider : data.calendar.toLowerCase(),
                    email    : data.email,
                    user_id  : distributedCalendar.data_dict[`${data.email}_${state.calendar}`]?.owner,
                    body     : mbody,
                }])
                setLoading(false)

                if (!mresponse[0]) {
                    useNotification(
                        "Ops",
                        "Algo deu errado, tente novamente.",
                        "danger"
                    )
                    setLoading(false)
                    return
                }

                if (data.send_whatsapp_notification)
                    await handleCreateNotifications(data, mresponse[0])
                setLoading(false)

                if (["WEEKLY", "MONTHLY", "YEARLY", "WEEKDAYS"].includes(data.is_recurrent)) {
                    distributedCalendar.reload_calendar()
                } else {
                    const mupdatedEvents = [...timelineTasks, buildExternalEventObject(mresponse[0], data)]
                    processEvents(mupdatedEvents)
                }

                handleClose()
                useNotification(
                    "Sucesso",
                    "Evento criado com sucesso.",
                    "success"
                )
                break
            default:
                console.warn(`Unknown calendar ${data.calendar}`)
        }
    }

    const createEvent = async (data) => {
        if (data.calendar !== "KWIK") {
            createExternalEvent(data)
            return
        }

        setLoading(true)
        const response = await api.post(`api/enterprises/${getSession().profile.enterprise.id}/tasks/`, {
            ...data,
            description: data.title,
            long_description: data.description,
            target_date: dayjs(data.startDate).format("YYYY-MM-DDTHH:mm"),
            contact: (data.contact) ? data.contact.id : null,
            contact_enterprise: (data.contact_enterprise) ? data.contact_enterprise.id : null,
            owner: getSession().id,
            status: "SCHEDULED",
            target: (!data.target) ? getSession().id : data.target,
            is_recurrent: (data.is_recurrent === "UNIQUE") ? "" : data.is_recurrent
        })
        setLoading(false)
        if (response.status === 201) {
            const updatedEvents = [
                ...timelineTasks, 
                ...response.data.map(event => eventObject({object: event, provider: 'KWIK', source: event.target_username}))
            ]
            processEvents(updatedEvents)
            handleClose()
            useNotification(
                "Sucesso",
                "Tarefa criada com sucesso.",
                "success"
            )
            return
        }
        await useNotification(
            "Ops",
            "Algo deu errado, tente novamente.",
            "danger"
        )
    }

    const deleteEvent = async (data, recurrent=false) => {
        let response
        switch (data.calendar) {
            case "GOOGLE_CALENDAR":
                if (data.is_recurrent !== "UNIQUE" && recurrent) {
                    const until = dayjs(data.startDate).utc().subtract(1, "second").format("YYYYMMDDTHHmmss[Z]")
                    setLoading(true)
                    const master = await oauthRequest([{
                        url: `/${data.is_recurrent}`,
                        method: "GET",
                        provider: "google_calendar",
                        email: data.email,
                        user_id: distributedCalendar.data_dict[`${data.email}_${state.calendar}`]?.owner
                    }])
                    if (master[0]) {
                        const updatedRecurrence = master[0].recurrence.map(rule => {
                            if (!rule.startsWith("RRULE")) return rule
                            return rule.replace(/;UNTIL=[^;]+/, "") + `;UNTIL=${until}`
                        })
                        const params = new URLSearchParams()
                        let url = `/${data.is_recurrent}`
                        if (data.send_notification)
                            url += "?sendUpdates=all"
                        response = await oauthRequest([{
                            url: url,
                            method: "PATCH",
                            provider: "google_calendar",
                            email: data.email,
                            user_id: distributedCalendar.data_dict[`${data.email}_${state.calendar}`]?.owner,
                            body: {
                                recurrence: updatedRecurrence
                            }
                        }])
                        if (response[0] && data.id !== data.is_recurrent) {
                            let deleteCurrentUrl = `/${data.id}`
                            if (data.send_notification)
                                deleteCurrentUrl += "?sendUpdates=all"

                            await oauthRequest([{
                                url: deleteCurrentUrl,
                                method: "DELETE",
                                provider: "google_calendar",
                                email: data.email,
                                user_id: distributedCalendar.data_dict[`${data.email}_${state.calendar}`]?.owner
                            }])
                        }
                        await handleDeleteNotifications(data, response[0])
                    }
                    setLoading(false)
                    distributedCalendar.reload_calendar()   
                } else {
                    const params = new URLSearchParams()
                    let url = `/${data.id}`
                    if (data.send_notification)
                        url += "?sendUpdates=all"
                    
                    setLoading(true)
                    response = await oauthRequest([{
                        url      : url,
                        method   : "DELETE",
                        provider : data.calendar.toLowerCase(),
                        email    : data.email,
                        user_id  : distributedCalendar.data_dict[`${data.email}_${state.calendar}`]?.owner
                    }])

                    await handleDeleteNotifications(data, response[0])
                    setLoading(false)
                    
                    const updatedEvents = timelineTasks.filter((event) => event.id !== data.id)
                    processEvents(updatedEvents)
                }
                handleClose()
                useNotification(
                    "Sucesso",
                    "Evento excluído com sucesso.",
                    "success"
                )
                break
            case "MICROSOFT_CALENDAR":
                if (data.is_recurrent !== "UNIQUE" && recurrent) {
                    setLoading(true)
                    const master = await oauthRequest([{
                        url: `/events/${data.is_recurrent}`,
                        method: "GET",
                        provider: "microsoft_calendar",
                        email: data.email,
                        user_id: distributedCalendar.data_dict[`${data.email}_${state.calendar}`]?.owner
                    }])
                    if (master[0]) {
                        const selectedDate = dayjs(data.startDate).format("YYYY-MM-DD")
                        const masterStartDate = master[0]?.recurrence?.range?.startDate

                        if (masterStartDate && !dayjs(selectedDate).isAfter(dayjs(masterStartDate), "day")) {
                            let deleteMasterUrl = `events/${data.is_recurrent}`
                            if (data.send_notification)
                                deleteMasterUrl += "?sendUpdates=all"

                            response = await oauthRequest([{
                                url: deleteMasterUrl,
                                method: "DELETE",
                                provider: "microsoft_calendar",
                                email: data.email,
                                user_id: distributedCalendar.data_dict[`${data.email}_${state.calendar}`]?.owner
                            }])
                        } else {
                            const endDate = dayjs(data.startDate).subtract(1, "day").format("YYYY-MM-DD")
                            response = await oauthRequest([{
                                url: `/events/${data.is_recurrent}`,
                                method: "PATCH",
                                provider: "microsoft_calendar",
                                email: data.email,
                                user_id: distributedCalendar.data_dict[`${data.email}_${state.calendar}`]?.owner,
                                body: {
                                    recurrence: {
                                        pattern: master[0].recurrence.pattern,
                                        range: {
                                            type: "endDate",
                                            startDate: master[0].recurrence.range.startDate,
                                            endDate
                                        }
                                   }
                                }
                            }])
                            if (response[0] && data.id !== data.is_recurrent) {
                                let deleteCurrentUrl = `events/${data.id}`
                                if (data.send_notification)
                                    deleteCurrentUrl += "?sendUpdates=all"

                                await oauthRequest([{
                                    url: deleteCurrentUrl,
                                    method: "DELETE",
                                    provider: "microsoft_calendar",
                                    email: data.email,
                                    user_id: distributedCalendar.data_dict[`${data.email}_${state.calendar}`]?.owner
                                }])
                            }
                        }
                        await handleDeleteNotifications(data, response[0])
                    }
                    setLoading(false)
                    distributedCalendar.reload_calendar()
                } else {
                    const mparams = new URLSearchParams()
                    let url = `events/${data.id}`
                    if (data.send_notification)
                        url += "?sendUpdates=all"
                    
                    setLoading(true)
                    response = await oauthRequest([{
                        url      : url,
                        method   : "DELETE",
                        provider : data.calendar.toLowerCase(),
                        email    : data.email,
                        user_id  : distributedCalendar.data_dict[`${data.email}_${state.calendar}`]?.owner
                    }])
                    
                    await handleDeleteNotifications(data, response[0])
                    setLoading(false)

                    const updatedEvents = timelineTasks.filter((event) => event.id !== data.id)
                    processEvents(updatedEvents)
                }
                handleClose()
                useNotification(
                    "Sucesso",
                    "Evento excluído com sucesso.",
                    "success"
                )
                break
            default:
                response = await api.delete(`api/enterprises/${getSession().profile.enterprise.id}/tasks/${data.id}/?recurrent=${recurrent}`)
                if (response.status === 204) {
                    const kupdatedEvents = timelineTasks.filter((event) => event.id !== data.id)

                    if (recurrent)
                        distributedCalendar.reload_calendar()
                    else 
                        processEvents(kupdatedEvents)

                    handleClose()

                    useNotification(
                        "Sucesso",
                        (recurrent) ? "Eventos excluídos com sucesso." : "Evento excluído com sucesso.",
                        "success"
                    )
                    return
                }
                useNotification(
                    "Ops",
                    "Algo deu errado, tente novamente.",
                    "danger"
                )
                break
        }
    }

    const enterpriseSearchFn = useCallback(async (search = '', timeout = 1000) => {
        clearTimeout(timeouts.enterprise)
        const Fn = async () => {
            setSmallLoading(true)
            try {
                let url = `api/enterprises/${getSession().profile.enterprise.id}/contact_enterprises/paginated/?page=1&pageSize=25`
                if (search)
                    url = `${url}&name__contains=${search}`
                const response = await api.get(url)
                setEnterprises(response.data.results)
            } catch (error) { } finally {
                setSmallLoading(false)
            }
        }
        if (timeout){
            timeouts.enterprise = setTimeout(Fn, timeout)
        } else {
            return Fn()
        }
    }, [])

    const contactGroupSearchFn = useCallback(async (search='', timeout=1000) => {
        clearTimeout(timeouts.groups)
        const Fn = async () => {
            setSmallLoading(true)
            try {
                let url = `api/enterprises/${getSession().profile.enterprise.id}/contact_group/noserialize/`
                if (search)
                    url = `${url}?search=${search}`
                const response = await api.get(url)
                setContactGroups(response.data.results)
            } catch (error) { } finally {
                setSmallLoading(false)
            }
        }
       if (timeout){
            timeouts.groups = setTimeout(Fn, timeout)
        } else {
            return Fn()
        }
    }, [])

    const initialize = useCallback(async () => {

        const Fn = async () => {
            const response = await api.get(`api/enterprises/${getSession()?.profile?.enterprise?.id}/tasks/${selectedEvent?.id}/`)
                    if (response.status === 200) {
                        setState({
                            ...eventObject({object: response.data, provider: 'KWIK', email: response.data.target_email}),
                        })
                        setReady(true)
                    }
        }
        
        if (selectedEvent?.id) {
            if (selectedEvent?.calendar !== "KWIK") {
                setState({
                    ...selectedEvent,
                })
                setReady(true)
            } else Fn()
        }
        else {
            setLoading(true)
            await distributedCalendar.lazy_data()
            setLoading(false)
            setReady(true)
        }
    }, [selectedEvent])

    const externalAgendas = distributedCalendar.data.reduce((acc, { provider, email }) => {
        if (!acc[provider])
            acc[provider] = []
        acc[provider].push(email)
        return acc
    }, {})

    useEffect(() => {
        const fetchEvents = async () => {
            const enterpriseId = getSession().profile.enterprise.id
            const [eventsResponse, customEventsResponse, enterpriseEvents, teamResponse] = await Promise.all([
                api.get(`api/message_events/`),
                api.get(`api/enterprises/${enterpriseId}/custom_events/`),
                api.get(`api/enterprises/${enterpriseId}/message_events/`),
                api.get(`api/users/${getSession().id}/myteam/`),
                contactSearchFn('', 0),
                enterpriseSearchFn('', 0),
                contactGroupSearchFn('', 0),
                initialize()
            ])
            setEvents((eventsResponse.status === 200) ? eventsResponse.data : [])
            setCustomEvents((customEventsResponse.status === 200) ? customEventsResponse.data : [])
            setEnterpriseEvents((enterpriseEvents.status === 200) ? enterpriseEvents.data : [])
            setUserTeam((teamResponse.status === 200) ? teamResponse.data[0].members_data : [])
        }
        fetchEvents()
    }, [])


    useEffect(() => {
        if (state.activity) {
            window.activity = state.activity
        }
        return () => {
            window.activity = null
        }
    }, [state.activity, state.type])

    useEffect(() => {
    if (!state.event || enterpriseEvents.length === 0)
        return

    const setupEvent = async () => {
        const settings = enterpriseEvents.find((event) => event.event == state.event)
        if (settings) {
            let currentTemplates = templates
            if (templates.length === 0) {
                const fetchedTemplates = await getTemplates(settings.sender)
                setTemplates(fetchedTemplates)
                currentTemplates = fetchedTemplates
            }
            const template = currentTemplates.find((t) => t.name === settings.message_content)
            setEventSettings({ ...settings, template: template })
        } else { setEventSettings({}) } // unsetting 
    }
    setupEvent()
}, [state.event, enterpriseEvents, templates])

    const submit = (recurrent=false) => {
        const data = {
            ...state,
            contact: contactType === "contact" ? state.contact : null,
            contact_enterprise: contactType === "contact_enterprise" ? state.contact_enterprise : null,
            contact_group: contactType === "contact_group" ? state.contact_group?.id : null
        }
        if (data.id){
            updateEvent(data, recurrent) 
            return
        }
            createEvent(data)
    }

    const createNewEvent = async (name) => {
        const enterpriseId = getSession().profile.enterprise.id
        const response = await api.post(`api/enterprises/${enterpriseId}/custom_events/`, {
            name: name,
            identifier: name.toUpperCase(),
            type: "Agenda"
        })
        if (response.status === 201) {
            useNotification("Sucesso", "Tipo customizado adicionado com sucesso.", "success")
            setCustomEvents((prevState) => [...prevState, response.data])
            setParentCustomEvents((prevState) => [...prevState, response.data])
            setShowCreateNewEvent(false)
            return
        }
        useNotification("Ops", "Algo deu errado, tente novamente.", "danger")
    }

    const getNumberTemplates = useCallback(async (number) => {
        if (!number) return []
        const enterpriseId = getSession().profile.enterprise.id
        const response = await api.get(`/api/enterprises/${enterpriseId}/templates/`, { timeout: 0 })
        if (response.status === 200) {
            return response.data[number]?.waba_templates?.filter((template) => {
                return (template.status == "APPROVED" &&
                    template.language == "pt_BR" &&
                    !template.name.includes("sample_"))
            }) ?? []
        }
        return []
    }, [])

    const getTemplates = async (number) => {
        const enterpriseId = getSession().profile.enterprise.id
        const response = await api.get(`/api/enterprises/${enterpriseId}/templates/`, { timeout: 0 })
        if (response.status === 200) {
            return response.data[number]?.waba_templates?.filter((template) => {
                return (template.status == "APPROVED" &&
                    template.language == "pt_BR" &&
                    !template.name.includes("sample_"))
            }) ?? []
        }
        return []
    }

    const parseOffsetTime = (timeStr) => {
        if (!timeStr)
            return ""

        const [hours, minutes, seconds] = timeStr.split(":").map(Number)

        const parts = []
        if (hours > 0) parts.push(`${hours} hora${hours > 1 ? "s" : ""}`)
        if (minutes > 0) parts.push(`${minutes} minuto${minutes > 1 ? "s" : ""}`)

        return parts.join(" e ")
    }

    const createNewContact = async (name, email, telephone, userFields, advisor, contactEnterprise, cpf, customer_code, groups, toCreateCustomFields, notificationOptOut, owner, birthday, linkedin_url) => {
        if (! name && ! email && ! telephone) {
            useNotification(
                "Atenção!",
                "Insira pelo menos um: nome, email, ou telefone.",
                "warning"
            )
            return
        }
        
        const formatTelephone = formatPhone(telephone)
        
        const payload = {
            nick                 : (telephone) ? formatTelephone : (email) ? email : await generateUniqueNick(),
            name                 : name,
            email                : email,
            telephone            : formatTelephone,
            user_fields          : userFields,
            advisor              : advisor,
            contact_enterprise   : contactEnterprise,
            cpf                  : cpf,
            customer_code        : customer_code,
            notification_opt_out : notificationOptOut,
            groups               : groups,
            owner                : owner === "" ? null : owner,
            birthday             : (birthday) ? dayjs(birthday, "DD/MM/YYYY").format("YYYY-MM-DDTHH:mm") : null,
            linkedin_url         : linkedin_url
        }
        
        setLoading(true)
        const enterpriseId = getSession().profile.enterprise.id
        const response = await api.post(`/api/enterprises/${enterpriseId}/contacts/`, payload)
        setLoading(false)
        
        if (response.status !== 201) {
            handleContactCreateErrors(response)
            return
        }

        showCreateNewContactDialog(false)
        const createdContact = response.data

        setContacts((prevState) => [
            createdContact,
            ...prevState.filter((contact) => contact.id !== createdContact.id)
        ])
        setState((prevState) => ({ ...prevState, contact: createdContact }))
        setContactSearch(
            createdContact.name || createdContact.email || createdContact.telephone || ""
        )
    }

    const isDisabled = () => {

        switch (state.calendar) {
            case "GOOGLE_CALENDAR":
                return state.id && state.email !== state.organizer
            case "MICROSOFT_CALENDAR":
                return state.id && state.email !== state.organizer
            case "KWIK":
                return state.id && state.owner !== getSession().id
            default:
                return true
        }
    }

    const changeEventStatus = useCallback(async (event) => {
        setLoading(true)
        switch(state.calendar) {
            case 'MICROSOFT_CALENDAR':
                {

                    let url = `events/${state.id}/${stateTranslation[event]?.vMicrosoft}`

                    const body = { "comment": "Voy", "sendResponse": true }

                    const [res] = await oauthRequest([
                        {
                            url: url,
                            method: 'POST',
                            provider: state.calendar.toLowerCase(),
                            email: state.email,
                            user_id: distributedCalendar.data_dict[`${state.email}_${state.calendar}`]?.owner,
                            body: body
                        }
                    ])
                }
                break
            case 'GOOGLE_CALENDAR':
                {

                    let url = `/${state.id}?sendUpdates=all`

                    const attendees = state.attendees.map(attendee => {
                        if (attendee.email === state.email)
                            return { "email": state.email, "responseStatus": event }
                        return attendee
                    })

                    const [res] = await oauthRequest([
                        {
                            url: url,
                            method: 'PATCH',
                            provider: state.calendar.toLowerCase(),
                            email: state.email,
                            user_id: distributedCalendar.data_dict[`${state.email}_${state.calendar}`]?.owner,
                            body: {"attendees": attendees}
                        }
                    ])
                }
                break
            default: 
                break
        }
        setLoading(false)
        useNotification('Sucesso!', 'Resposta enviada com sucesso!', 'success')
        setConfirmEvent(null)
        await distributedCalendar.reload_calendar()
        handleClose()
    }, [state, confirmEvent])

    return (
        <div>
            <Loading loading={!ready || loading} />
            {Boolean(confirmEvent) && 
            <ConfirmationDialog 
                open={true}
                handleClose={()=> setConfirmEvent(null)}
                title={'Confirmar participação'}
                description={<>Deseja confirmar presença como "{stateTranslation[confirmEvent]?.present}" no evento {state.title}?</>}
                handleSubmit={() => changeEventStatus(confirmEvent)}
            />}
            <Dialog
                open={ready}
                keepMounted
                onClose={()=>{}}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                disablePortal
                disableEnforceFocus
                sx={{ position: "fixed" }}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle id="alert-dialog-slide-title" sx={{ display: "flex", justifyContent: "space-between" }}>
                    {title}
                    <Box>
                        {userGroups.isSupervisor &&
                            <Button onClick={() => window.open("https://instant.getoutline.com/s/canal-do-cliente/doc/criando-eventos-na-agenda-e-automatizando-notificacoes-G0Rn78oIZL", "_blank")}>FAQ</Button>
                        }
                        <Button sx={{ 'minWidth': '2rem', 'padding': '0' }} onClick={handleClose} ><CloseIcon /></Button>
                    </Box>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    {showCreateNewEvent &&
                        <Dialog open={showCreateNewEvent} onClose={() => setShowCreateNewEvent(false)}>
                            <DialogTitle>Novo tipo</DialogTitle>
                            <DialogContent sx={{ paddingTop: ".5rem !important" }}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Tipo"
                                    value={newEventName}
                                    onChange={(e) => setNewEventName(e.target.value)}
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setShowCreateNewEvent(false)}>Cancelar</Button>
                                <Button onClick={() => createNewEvent(newEventName)} disabled={!newEventName.trim()}>
                                    Salvar
                                </Button>
                            </DialogActions>
                        </Dialog>
                    }
                    {state.event !== "BIRTHDAY" &&
                        <>
                            {Object.keys(externalAgendas).length !== 0 &&
                                <>
                                    <Box className="category-title push-bottom">
                                        Agenda
                                    </Box>
                                    <Box display="flex" gap={1}>
                                        <Button
                                            variant={state.calendar === "KWIK" ? "contained" : "outlined"}
                                            color="primary"
                                            sx={{ flex: 1 }}
                                            onClick={() => setState((prevState) => ({ ...prevState, calendar: "KWIK" }))}
                                            disabled={Boolean(state.id)}
                                        >
                                            Kwik
                                        </Button>
                                        {"GOOGLE_CALENDAR" in externalAgendas &&
                                            <Button
                                                variant={state.calendar === "GOOGLE_CALENDAR" ? "contained" : "outlined"}
                                                color="primary"
                                                sx={{ flex: 1 }}
                                                onClick={() => setState((prevState) => ({ ...prevState, calendar: "GOOGLE_CALENDAR" }))}
                                                disabled={Boolean(state.id)}
                                            >
                                                Google
                                            </Button>
                                        }
                                        {"MICROSOFT_CALENDAR" in externalAgendas &&
                                            <Button
                                                variant={state.calendar === "MICROSOFT_CALENDAR" ? "contained" : "outlined"}
                                                color="primary"
                                                sx={{ flex: 1 }}
                                                onClick={() => setState((prevState) => ({ ...prevState, calendar: "MICROSOFT_CALENDAR" }))}
                                                disabled={Boolean(state.id)}
                                            >
                                                Microsoft
                                            </Button>
                                        }
                                    </Box>
                                </>
                            }
                            {state.calendar !== "KWIK" &&
                                <>
                                    <FormControl fullWidth size="small" className="push-top">
                                        <InputLabel>E-mail</InputLabel>
                                        <Select
                                            value={state.email}
                                            label="E-mail"
                                            onChange={(event) => setState((prevState) => ({ ...prevState, email: event.target.value }))}
                                            disabled={Boolean(state.id)}
                                        >
                                            {externalAgendas[state.calendar]?.map((email) => (
                                                <MenuItem value={email}>{email}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    {distributedCalendar.calendar_ownership(state) &&
                                     (state.attendees || []).find(attendee => attendee.email === state.email && attendee.status === 'pending') && 
                                     <>
                                        <Box className="category-title push-bottom push-top">
                                            Confirmar presença?
                                        </Box>
                                        <Box display='flex' gap='1rem'>
                                            <Button onClick={()=> setConfirmEvent('accepted') } sx={{flex: 1}} color='success' variant='contained'>Sim   </Button>
                                            <Button onClick={()=> setConfirmEvent('declined') } sx={{flex: 1}} color='error'   variant='contained'>Não   </Button>
                                            <Button onClick={()=> setConfirmEvent('tentative')} sx={{flex: 1}} color='warning' variant='contained'>Talvez</Button>
                                        </Box>
                                    </>
                                    }
                                </>
                            }
                            {state.calendar === "KWIK" && isSupervisor &&
                                <>
                                    <FormControl className="push-top" fullWidth size="small" disabled={isDisabled()}>
                                        <InputLabel>Responsável</InputLabel>
                                        <Select
                                            value={userTeam.some(member => member.id === state.target) ? state.target : getSession().id}
                                            label="Responsável"
                                            onChange={(event) => setState((prevState) => ({ ...prevState, target: event.target.value }))}
                                        >
                                            <MenuItem value={getSession().id}>Eu mesmo</MenuItem>
                                            <Divider />
                                            <ListSubheader>Operadores</ListSubheader>
                                            {userTeam.sort((a, b) => a.first_name.localeCompare(b.first_name) || a.last_name.localeCompare(b.last_name)).map((member) => (
                                                <MenuItem value={member.id}>
                                                    {member.first_name} {member.last_name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </>
                            }
                            <Box className="category-title push-top push-bottom">
                                Detalhes do evento
                            </Box>
                            <TextField
                                size="small"
                                label="Assunto"
                                fullWidth
                                type="text"
                                variant="outlined"
                                value={state.title}
                                onChange={(event) => setState((prevState) => ({ ...prevState, title: event.target.value }))}
                                disabled={isDisabled()}
                            />
                            <TextField
                                size="small"
                                multiline
                                maxRows={6}
                                label={
                                <Box display='flex' alignItems='center' gap='1rem'>
                                <Box>Descrição</Box>
                                {(state.description || '').length > 0 && 
                                    <Tooltip title='Visualizador HTML'>
                                        <IconButton sx={{padding: 0}} color="primary" onClick={()=>setShowHTML(true)}>
                                            <VisibilityIcon/>
                                        </IconButton>
                                    </Tooltip>
                                }
                                </Box>
                                }
                                fullWidth
                                type="text"
                                variant="outlined"
                                value={state.description}
                                onChange={(event) => setState((prevState) => ({ ...prevState, description: event.target.value }))}
                                className="push-top"
                                disabled={isDisabled()}
                            />
                            <DraggableBox 
                                show={showHTML} 
                                handleClose={()=>setShowHTML(false)} 
                                x={0}
                                y={0} 
                                className='draggable-box-email'
                                title='Visualização do evento'
                            >
                                <Shadow>
                                    {ReactHtmlParser(state.description)}
                                </Shadow>
                            </DraggableBox>
                            {state.calendar !== "KWIK" &&
                                <TextField
                                    size="small"
                                    label="Localização"
                                    fullWidth
                                    type="text"
                                    variant="outlined"
                                    value={state.localization}
                                    onChange={(event) => setState((prevState) => ({ ...prevState, localization: event.target.value }))}
                                    className="push-top"
                                    disabled={isDisabled()}
                                />
                            }
                            <LocalizationProvider sx={{ justifyContent: 'space-between' }}
                                dateAdapter={AdapterDayjs}
                                adapterLocale={'pt-br'}
                                localeText={localePTBR.components.MuiLocalizationProvider.defaultProps.localeText}
                            >
                                <Box className='automation-end-form-control' sx={{ width: "100%", justifyContent: 'space-between' }}>
                                    <DemoContainer components={['DatePicker']} sx={{ width: "100%" }}>
                                        <DateTimePicker
                                            sx={{ minWidth: '8rem' }}
                                            views={['day', 'month', 'year', 'hours', 'minutes']}
                                            format={"DD/MM/YYYY HH:mm"}
                                            timezone={default_timezone}
                                            timeSteps={1}
                                            slotProps={{
                                                textField: {
                                                    label: "Início",
                                                    size: "small",
                                                    sx: { width: "100%", marginTop: "20px" }
                                                }
                                            }}
                                            value={(state.startDate) ? dayjs(state.startDate) : null}
                                            onChange={(event) => {
                                                if (event)
                                                    setState((prevState) => ({ ...prevState, startDate: event }))
                                            }}
                                            dayOfWeekFormatter={(n, date) => number2dayweek[date.$W]}
                                            disabled={isDisabled()}
                                        />
                                    </DemoContainer>
                                </Box>
                                {state.calendar !== "KWIK" &&
                                    <Box className='automation-end-form-control' sx={{ width: "100%", justifyContent: 'space-between' }}>
                                        <DemoContainer components={['DatePicker']} sx={{ width: "100%" }}>
                                            <DateTimePicker
                                                sx={{ minWidth: '8rem' }}
                                                views={['day', 'month', 'year', 'hours', 'minutes']}
                                                format={"DD/MM/YYYY HH:mm"}
                                                timezone={default_timezone}
                                                timeSteps={1}
                                                slotProps={{
                                                    textField: {
                                                        label: "Fim",
                                                        size: "small",
                                                        sx: { width: "100%", marginTop: "20px" }
                                                    }
                                                }}
                                                value={(state.endDate) ? dayjs(state.endDate) : null}
                                                onChange={(event) => {
                                                    if (event)
                                                        setState((prevState) => ({ ...prevState, endDate: event }))
                                                }}
                                                dayOfWeekFormatter={(n, date) => number2dayweek[date.$W]}
                                                disabled={isDisabled()}
                                            />
                                        </DemoContainer>
                                    </Box>
                                }
                            </LocalizationProvider>
                            {(state.calendar === "KWIK" || ! state.id) &&
                                <FormControl fullWidth size="small" className="push-top">
                                    <InputLabel>Recorrência</InputLabel>
                                    <Select
                                        value={state.is_recurrent}
                                        label="Recorrência"
                                        onChange={(event) => setState((prevState) => ({ ...prevState, is_recurrent: event.target.value }))}
                                        disabled={Boolean(state.id)}
                                    >
                                        <MenuItem value="UNIQUE">Único</MenuItem>
                                        <MenuItem value="WEEKDAYS">Dias da semana</MenuItem>
                                        <MenuItem value="WEEKLY">Semanal</MenuItem>
                                        <MenuItem value="MONTHLY">Mensal</MenuItem>
                                        <MenuItem value="YEARLY">Anual</MenuItem>
                                    </Select>
                                </FormControl>
                            }
                            {state.calendar === "KWIK" &&
                                <>
                                    <FormControl fullWidth size="small" className="push-top" disabled={isDisabled()}>
                                        <InputLabel>Tipo</InputLabel>
                                        <Select
                                            value={state.event}
                                            label="Tipo"
                                            onChange={(event) => setState((prevState) => ({ ...prevState, event: event.target.value, activity: null }))}
                                        >
                                            <MenuItem key="ACTIVE" value="ACTIVE">Atividade</MenuItem>
                                            <Divider />
                                            <ListSubheader>Sistema</ListSubheader>
                                            {events.filter((event) => event.identifier !== "BIRTHDAY").map((event) => (
                                                <MenuItem key={event.identifier} value={event.identifier}>{event.name}</MenuItem>
                                            ))}
                                            <Divider />
                                            <ListSubheader sx={{ display: "flex", gap: ".5rem" }}>
                                                Customizados
                                                {userGroups.isSupervisor &&
                                                    <IconButton onClick={() => setShowCreateNewEvent(true)}>
                                                        <AddIcon />
                                                    </IconButton>
                                                }
                                            </ListSubheader>
                                            {customEvents.map((event) => (
                                                <MenuItem key={event.identifier} value={event.identifier}>{event.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    {state.event === 'ACTIVE' &&
                                        <Box className='channel-select-activity'>
                                            <Box className='event-relativebox'>
                                                <Button variant={state.activity?.whatsapp ? 'contained' : 'standard'}
                                                    disabled={state.contact && checkDisabled('whatsapp', state.contact)}
                                                    onClick={async () => {
                                                        setLoading(true)
                                                        if (state.activity?.whatsapp) {
                                                            window.activity = state.activity
                                                        }
                                                        await setupWhatsAppNotify({}, async (data) => { 
                                                            return await handleWhatsappActivity(data, setState, setLoading) 
                                                        })
                                                        setLoading(false)
                                                    }}>WHATSAPP
                                                </Button>
                                                {state.activity?.whatsapp &&
                                                    <Tooltip title='Remover'>
                                                        <IconButton onClick={() => {
                                                            setState(prevState => {
                                                                delete prevState.activity.whatsapp
                                                                return { ...prevState }
                                                            })
                                                        }} className='internal-cancel-button'>
                                                            <CancelIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                }
                                            </Box>
                                            <Box className='event-relativebox'>
                                                <Button variant={state.activity?.email ? 'contained' : 'standard'}
                                                    disabled={state.contact && checkDisabled('email', state.contact)}
                                                    onClick={() => setupEmailNotify({}, (data) => { handleEmailActivity(data, setState) }, contactType === 'contact')}>EMAIL</Button>
                                                {state.activity?.email &&
                                                    <Tooltip title='Remover'>
                                                        <IconButton onClick={() => {
                                                            setState(prevState => {
                                                                delete prevState.activity.email
                                                                return { ...prevState }
                                                            })
                                                        }} className='internal-cancel-button'>
                                                            <CancelIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                }
                                            </Box>
                                            <Box className='event-relativebox'>
                                                <Button variant={state.activity?.sms ? 'contained' : 'standard'}
                                                    disabled={state.contact && checkDisabled('sms', state.contact)}
                                                    onClick={() => setupSMSNotify({}, (data) => { setState(prevState => ({ ...prevState, activity: { ...prevState.activity, 'sms': data } })) })}>SMS</Button>
                                                {state.activity?.sms &&
                                                    <Tooltip title='Remover'>
                                                        <IconButton onClick={() => {
                                                            setState(prevState => {
                                                                delete prevState.activity.sms
                                                                return { ...prevState }
                                                            })
                                                        }} className='internal-cancel-button'>
                                                            <CancelIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                }
                                            </Box>
                                        </Box>
                                    }
                                    {state.calendar === "KWIK" && Object.keys(eventSettings).length !== 0 && eventSettings.template &&
                                        <Box className="event-template-container">
                                            <Alert severity="info">
                                                <Box>Este tipo de evento possui uma configuração de disparo automático <strong>{parseOffsetTime(eventSettings.send_offset_time)}</strong> antes do evento.</Box>
                                                <Box sx={{ marginTop: "1rem" }}>Deseja manter o disparo abaixo?</Box>
                                                <RadioGroup row value={state.send_notification ? "yes" : "no"} onChange={(e) => setState((prevState) => ({ ...prevState, send_notification: e.target.value === "yes" }))}>
                                                    <FormControlLabel value="yes" control={<Radio />} label="Sim" />
                                                    <FormControlLabel value="no" control={<Radio />} label="Não" />
                                                </RadioGroup>
                                            </Alert>
                                            <Box className="event-template-visualization">
                                                <ParameterFiller
                                                    mediaValues={eventSettings.template.components}
                                                    parameters={[]}
                                                    submitParameters={eventSettings.message_parameters}
                                                    setReady={() => { }}
                                                />
                                            </Box>
                                        </Box>
                                    }
                                    {Boolean(state.id) &&
                                        <FormControl fullWidth size="small" className="push-top">
                                            <InputLabel>Status</InputLabel>
                                            <Select value={state.status} label="Status" onChange={(event) => setState((prevState) => ({ ...prevState, status: event.target.value }))}>
                                                <MenuItem value="SCHEDULED">Agendado</MenuItem>
                                                <MenuItem value="COMPLETED">Finalizado</MenuItem>
                                                <MenuItem value="CANCELLED">Cancelado</MenuItem>
                                            </Select>
                                        </FormControl>
                                    }
                                </>
                            }
                            <Box display="flex" justifyContent="space-between" className="category-title push-top push-bottom">
                                Contato(s)
                                {(!state.id || state.id && state.calendar === "KWIK") &&
                                    <FormControl sx={{ display: "flex", alignItems: "center" }}>
                                        <RadioGroup row value={contactType} onChange={(event) => setContactType(event.target.value)}>
                                            <FormControlLabel disabled={isDisabled() || lock} value="contact" control={<Radio sx={{ padding: "0 .25rem" }} />} label="Contato" />
                                            <FormControlLabel disabled={isDisabled() || lock} value="contact_enterprise" control={<Radio sx={{ padding: "0 .25rem" }} />} label="Empresa" />
                                            <FormControlLabel disabled={isDisabled() || lock} value="contact_group" control={<Radio sx={{ padding: "0 .25rem" }} />} label="Segmento" />
                                        </RadioGroup>
                                    </FormControl>
                                }
                            </Box>
                            {state.id && state.calendar !== "KWIK"
                                ? 
                                <>
                                    {state.attendees?.map((item) => {
                                        const email = item.email
                                        const responseStatus = item.status
                                        const isOrganizer = email === state.organizer
                                        return (
                                            <Box key={email} display="flex" alignItems="center" gap={1} mb={.5}>
                                                {(responseStatus === "accepted") &&
                                                    <CheckCircleIcon fontSize="small" color="success" />
                                                }
                                                {responseStatus === "pending" &&
                                                    <HelpIcon fontSize="small" color="warning" />
                                                }
                                                {responseStatus === "declined" &&
                                                    <DoNotDisturbOnIcon fontSize="small" color="error" />
                                                }
                                                {responseStatus === "creating" &&
                                                    <AddCircleOutlineIcon fontSize="small" color="success" />
                                                }
                                                {responseStatus === "tentative" &&
                                                    <ReportIcon fontSize="small" color="warning" />
                                                }
                                                <Box display="flex" alignItems="center" gap={.5}>
                                                    {email}
                                                    {isOrganizer ?
                                                        <Box sx={{ fontSize: ".95rem", color: "gray" }}>
                                                            (organizador)
                                                        </Box>
                                                    : 
                                                    <>
                                                        {!isDisabled() && <IconButton className='action-button delete' sx={{padding: '.1rem'}}
                                                            onClick={()=>setState(
                                                                prevState => (
                                                                    {...prevState, attendees: prevState.attendees.filter(attendee => attendee.email !== item.email)}))}
                                                        >
                                                                <DeleteIcon />
                                                        </IconButton>}
                                                    </>
                                                    }
                                                </Box>
                                            </Box>
                                        )
                                    })}
                                    {!isDisabled() && Boolean(state.id) && 
                                            <>
                                                <Box className="category-title push-top push-bottom">
                                                    Adicionar mais contatos
                                                </Box>
                                                <Box className="contact-input" >
                                                <Autocomplete
                                                    freeSolo
                                                    options={contacts.filter(contact => !state.attendees.map(attendee => attendee.email).includes(contact.email))}
                                                    getOptionLabel={(contact) => ((contact && contact.name) ? contact.name : "")}
                                                    loading={smallLoading}
                                                    onInputChange={(event, newValue) => {
                                                        if (event?.type !== 'change') return
                                                        contactSearchFn(newValue, 1000); setContactSearch(newValue)
                                                    }}
                                                    loadingText="Buscando contatos..."
                                                    inputValue={contactSearch}
                                                    renderInput={(params) => <TextField {...params}  label="Contato" variant="outlined" size="small" />}
                                                    //value={state.contact}
                                                    noOptionsText='Sem novas opções'
                                                    onChange={(event, newValue) => {
                                                        if (!newValue) return
                                                        
                                                        setState((prevState) => (
                                                        { ...prevState, attendees: [...prevState.attendees, {email:newValue.email, status:'creating' }]}))
                                                        setContactSearch('')
                                                        //setState(p => ({...p, contact: ''}))
                                                    }}
                                                    disabled={isDisabled() || lock}
                                                />
                                                {! hideNotifyRow &&
                                                    <Button 
                                                        sx={{ minWidth: "unset" }} 
                                                        onClick={() => showCreateNewContactDialog(true)}
                                                    >
                                                        <AddIcon />
                                                    </Button>
                                                }
                                            </Box>
                                            </>
                                            }
                                    </>
                                : <>
                                    {contactType === "contact" &&
                                        <>
                                            <Box className="contact-input">
                                                <Autocomplete
                                                    freeSolo
                                                    options={contacts}
                                                    getOptionLabel={(contact) => (
                                                        (contact && typeof contact === "object")
                                                            ? (contact.name || contact.email || contact.telephone || "")
                                                            : (contact || "")
                                                    )}
                                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                    loading={smallLoading}
                                                    inputValue={contactSearch}
                                                    onInputChange={(event, newValue, reason) => {
                                                        if (reason !== "input") return
                                                        setContactSearch(newValue)
                                                        contactSearchFn(newValue, 1000)
                                                    }}
                                                    loadingText="Buscando contatos..."
                                                    renderInput={(params) => <TextField {...params} label="Contato" variant="outlined" size="small" />}
                                                    value={state.contact || null}
                                                    onChange={(event, newValue) => {
                                                        const contact = (newValue && typeof newValue === "object") ? newValue : null
                                                        setState((prevState) => ({ ...prevState, contact }))
                                                        setContactSearch(
                                                            contact?.name || contact?.email || contact?.telephone || ""
                                                        )
                                                    }}
                                                    disabled={isDisabled() || lock}
                                                />
                                                {! hideNotifyRow &&
                                                    <Button 
                                                        sx={{ minWidth: "unset" }} 
                                                        onClick={() => showCreateNewContactDialog(true)}
                                                    >
                                                        <AddIcon />
                                                    </Button>
                                                }
                                            </Box>
                                            {state.contact && ! hideNotifyRow && (
                                                <Box className="contact-channels scheduler">
                                                    <Alert className='platform-alert-message' icon={false} severity='info'>
                                                        <span>Entrar em contato imediatamente</span>
                                                        <span>
                                                            {Object.keys(getSession().profile.enterprise.platforms)
                                                                .flatMap(key => {
                                                                    if (!(getSession().profile.enterprise.platforms[key] === true && ["whatsapp", "sms", "email"].includes(key))) return
                                                                    return (<IconButton key={key} disabled={checkDisabled(key, state.contact)}>
                                                                        {platforms(
                                                                            key,
                                                                            (() => {
                                                                                if (key === "whatsapp")
                                                                                    return () => setupWhatsAppNotify(state.contact)
                                                                                if (key === "sms")
                                                                                    return () => setupSMSNotify(state.contact)
                                                                                if (key === "email")
                                                                                    return () => setupEmailNotify(state.contact)
                                                                                return () => { }
                                                                            })()
                                                                        )}
                                                                    </IconButton>)
                                                                })}
                                                            {getSession().profile.enterprise.has_voice &&
                                                                <IconButton key="voice" disabled={checkDisabled('voice', state.contact)}>
                                                                    {platforms("voice", () => callContact(state.contact.telephone))}
                                                                </IconButton>
                                                            }
                                                        </span>
                                                    </Alert>
                                                </Box>
                                            )}
                                        </>
                                    }
                                    {contactType === "contact_enterprise" &&
                                        <Box className="contact-input">
                                            <Autocomplete
                                                freeSolo
                                                options={enterprises}
                                                getOptionLabel={(enterprise) => enterprise.name}
                                                loading={loading}
                                                onInputChange={(event, newValue) => {setEnterpriseSearch(newValue); enterpriseSearchFn(newValue, 1000)}}
                                                loadingText="Buscando empresas..."
                                                renderInput={(params) => <TextField {...params} label="Empresa" variant="outlined" size="small" />}
                                                value={state.contact_enterprise}
                                                onChange={(event, newValue) => setState((prevState) => ({ ...prevState, contact_enterprise: newValue }))}
                                                disabled={isDisabled() || lock}
                                            />
                                        </Box>
                                    }
                                    {contactType === "contact_group" &&
                                        <Box className="contact-input">
                                            <Autocomplete
                                                freeSolo
                                                options={contactGroups}
                                                getOptionLabel={(group) => group.name}
                                                loading={loading}
                                                onInputChange={(event, newValue) => {setContactGroupSearch(newValue); contactGroupSearchFn(newValue, 1000)}}
                                                loadingText="Buscando segmentos..."
                                                renderInput={(params) => <TextField {...params} label="Segmento" variant="outlined" size="small" />}
                                                value={state.contact_group}
                                                onChange={(event, newValue) => setState((prevState) => ({ ...prevState, contact_group: newValue }))}
                                                disabled={isDisabled() || lock}
                                            />
                                        </Box>
                                    }
                                </>
                            }
                            {state.calendar !== "KWIK" &&
                                <>
                                    <Box className="category-title push-top push-bottom">
                                        Videoconferência
                                    </Box>
                                    {Boolean(state.id)
                                        ? (state.conference_room)
                                            ? <Link sx={{overflowWrap: 'break-word'}} href={state.conference_room} target="_blank" rel="noopener noreferrer">
                                                {state.conference_room}
                                            </Link>
                                            : "Sem vídeo conferência"
                                        : <RadioGroup row value={state.conference_room ? "yes" : "no"} onChange={(e) => setState((prevState) => ({ ...prevState, conference_room: e.target.value === "yes" }))}>
                                            <FormControlLabel value="yes" control={<Radio />} label="Sim" />
                                            <FormControlLabel value="no" control={<Radio />} label="Não" />
                                        </RadioGroup>
                                    }
                                    <>
                                        <Box className="category-title push-top push-bottom">
                                            Notificar contatos por E-mail?
                                        </Box>
                                        <RadioGroup 
                                            row 
                                            value={state.send_notification ? "yes" : "no"}
                                            onChange={(e) => setState((prevState) => ({ ...prevState, send_notification: e.target.value === "yes" }))}
                                        >
                                            <FormControlLabel value="yes" control={<Radio />} label="Sim" />
                                            <FormControlLabel value="no" control={<Radio />} label="Não" />
                                        </RadioGroup>
                                        <Box className="category-title push-top push-bottom">
                                            Notificar contatos por WhatsApp?
                                        </Box>
                                        <RadioGroup 
                                            row 
                                            name="send_whatsapp_notification"
                                            value={state.send_whatsapp_notification ? "yes" : "no"}
                                            onChange={(e) => setState((prevState) => ({ ...prevState, send_whatsapp_notification: e.target.value === "yes" }))}
                                        >
                                            <FormControlLabel value="yes" control={<Radio />} label="Sim" />
                                            <FormControlLabel value="no" control={<Radio />} label="Não" />
                                        </RadioGroup>
                                    </>
                                </>
                            }
                        </>
                    }
                    {state.event === "BIRTHDAY" &&
                        <Box sx={{ minWidth: "20rem" }}>
                            <span style={{padding: '0 0.2rem'}}>{`Aniversário do contato: `}</span>
                            <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    handleClose()
                                    setProfile(state.contact)
                                }}
                            >
                                {state.contact?.name}
                            </span>
                            {! hideNotifyRow &&
                                <Box className="contact-channels scheduler">
                                    <Alert className='platform-alert-message' icon={false} severity='info'>
                                        <span>Entrar em contato imediatamente</span>
                                        <span>
                                            {Object.keys(getSession().profile.enterprise.platforms)
                                                .flatMap(key => {
                                                    if (!(getSession().profile.enterprise.platforms[key] === true && ["whatsapp", "sms", "email"].includes(key))) return
                                                    return (<IconButton key={key} disabled={checkDisabled(key, state.contact)}>
                                                        {platforms(
                                                            key,
                                                            (() => {
                                                                if (key === "whatsapp")
                                                                    return () => setupWhatsAppNotify(state.contact)
                                                                if (key === "sms")
                                                                    return () => setupSMSNotify(state.contact)
                                                                if (key === "email")
                                                                    return () => setupEmailNotify(state.contact)
                                                                return () => { }
                                                            })()
                                                        )}
                                                    </IconButton>)
                                                })}
                                            {getSession().profile.enterprise.has_voice &&
                                                <IconButton key="voice" disabled={checkDisabled('voice', state.contact)}>
                                                    {platforms("voice", () => callContact(state.contact.telephone))}
                                                </IconButton>
                                            }
                                        </span>
                                    </Alert>
                                </Box>
                            }
                        </Box>
                    }
                </DialogContent>
                {(distributedCalendar.calendar_ownership(state) || state.calendar === 'KWIK' || state.id === 0) && 
                <DialogActions>
                    {state.event !== "BIRTHDAY" &&
                        <Box display="flex" width="100%" alignItems="center">
                            {Boolean(state.id) &&
                                <Button onClick={() => setDeleteConfirmation(true)} sx={{ color: "red" }}>
                                    Excluir Evento
                                </Button>
                            }
                            <Box marginLeft="auto">
                                <Button onClick={handleClose} color="primary">
                                    Cancelar
                                </Button>
                                <Button
                                    onClick={() => state.id && state.is_recurrent && state.is_recurrent !== "UNIQUE" ? setConfirmation(true) : submit()}
                                    color="primary"
                                    disabled={
                                        !state.title ||
                                        !state.startDate ||
                                        (state.event === 'ACTIVE' && !(state.contact || state.contact_enterprise || state.contact_group)) ||
                                        (state.calendar === "KWIK" && ! state.event) ||
                                        (state.calendar !== "KWIK" && ! state.email)
                                    }
                                >
                                    Salvar
                                </Button>
                            </Box>
                        </Box>
                    }
                    {state.event === "BIRTHDAY" &&
                        <Button
                            onClick={handleClose}
                            color="primary">
                            Fechar
                        </Button>
                    }
                </DialogActions>}
            </Dialog>
            {confirmation &&
                <Dialog open={confirmation} onClose={() => setConfirmation(false)}>
                    <DialogTitle>Confirmação</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Deseja alterar os eventos recorrentes seguintes?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => submit()}>Não</Button>
                        <Button onClick={() => submit(true)}>Sim</Button>
                    </DialogActions>
                </Dialog>
            }
            {deleteConfirmation &&
                <Dialog open={deleteConfirmation} onClose={() => setDeleteConfirmation(false)}>
                    <DialogTitle>Confirmação</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {!state.is_recurrent || state.is_recurrent === "UNIQUE"
                                ? "Tem certeza que deseja excluir o evento?"
                                : "Tem certeza que deseja excluir os eventos recorrentes seguintes?"
                            }
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setDeleteConfirmation(false)}>Não</Button>
                        {state.is_recurrent && state.is_recurrent !== "UNIQUE" &&
                            <>
                                <Button onClick={() => deleteEvent(state)}>Somente este</Button>
                                <Button onClick={() => deleteEvent(state, true)}>Este e futuros</Button>
                            </>
                        }
                        {(!state.is_recurrent || state.is_recurrent === "UNIQUE") &&
                            <Button onClick={() => deleteEvent(state)}>Sim</Button>
                        }
                    </DialogActions>
                </Dialog>
            }
            {createNewContactDialog &&
                <ClientDialog 
                    open={true}
                    title="Novo contato"
                    type="create"
                    model={[]}
                    key={'ClientCreate'}
                    buttonText="Adicionar"
                    handleClose={() => showCreateNewContactDialog(false)}
                    submit={createNewContact}
                    is_financial_market_company={false}
                    isAdmin={false}
                    listOfUsers={[getSession()]}
                    groups={[]}
                    customFields={[]}
                />
            }
        </div>
    )
}

export default Event;
